import request from '@/utils/request'
import api from '../api'

export class Transaction {
  gatewaySearch(data) {
    return request({
      url: api.transaction.gatewaySearch,
      method: 'post',
      data
    })
  }
  gatewayDownload(data) {
    return request({
      url: api.transaction.gatewayDownload,
      method: 'post',
      data
    })
  }
  gatewayQuery(params) {
    return request({
      url: api.transaction.gatewayQuery,
      method: 'get',
      params
    })
  }
  authenticationSearch(data) {
    return request({
      url: api.transaction.authenticationSearch,
      method: 'post',
      data
    })
  }
  authenticationQuery(params) {
    return request({
      url: api.transaction.authenticationQuery,
      method: 'get',
      params
    })
  }
  authenticationDownload(data) {
    return request({
      url: api.transaction.authenticationDownload,
      method: 'post',
      data
    })
  }
  scanPaySearch(data) {
    return request({
      url: api.transaction.scanPaySearch,
      method: 'post',
      data
    })
  }
  scanPayQuery(params) {
    return request({
      url: api.transaction.scanPayQuery,
      method: 'get',
      params
    })
  }
  scanPayDownload(data) {
    return request({
      url: api.transaction.scanPayDownload,
      method: 'post',
      data
    })
  }
  refundSearch(data) {
    return request({
      url: api.transaction.refundSearch,
      method: 'post',
      data
    })
  }
  refundQuery(params) {
    return request({
      url: api.transaction.refundQuery,
      method: 'get',
      params
    })
  }
  refundDownload(data) {
    return request({
      url: api.transaction.refundDownload,
      method: 'post',
      data
    })
  }
  fastPaymentSearch(data) {
    return request({
      url: api.transaction.fastPaymentSearch,
      method: 'post',
      data
    })
  }
  fastPaymentQuery(params) {
    return request({
      url: api.transaction.fastPaymentQuery,
      method: 'get',
      params
    })
  }
  fastPaymentDownload(data) {
    return request({
      url: api.transaction.fastPaymentDownload,
      method: 'post',
      data
    })
  }
  onBehalfSearch(data) {
    return request({
      url: api.transaction.onBehalfSearch,
      method: 'post',
      data
    })
  }
  onBehalfQuery(params) {
    return request({
      url: api.transaction.onBehalfQuery,
      method: 'get',
      params
    })
  }
  onBehalfDownload(data) {
    return request({
      url: api.transaction.onBehalfDownload,
      method: 'post',
      data
    })
  }
  withdrawSearch(data) {
    return request({
      url: api.transaction.withdrawSearch,
      method: 'post',
      data
    })
  }
  withdrawDownload(data) {
    return request({
      url: api.transaction.withdrawDownload,
      method: 'post',
      data
    })
  }
  specialFastSearch(data) {
    return request({
      url: api.transaction.specialFastSearch,
      method: 'post',
      data
    })
  }
  specialFastDownload(data) {
    return request({
      url: api.transaction.specialFastDownload,
      method: 'post',
      data
    })
  }
  depositsSearch(data) {
    return request({
      url: api.transaction.depositsSearch,
      method: 'post',
      data
    })
  }
  depositsDownload(data) {
    return request({
      url: api.transaction.depositsDownload,
      method: 'post',
      data
    })
  }
  commitCustomSearch(data) {
    return request({
      url: api.transaction.commitCustomSearch,
      method: 'post',
      data
    })
  }
  commitCustomDownload(data) {
    return request({
      url: api.transaction.commitCustomDownload,
      method: 'post',
      data
    })
  }
  scanPayRefund(data) {
    return request({
      url: api.transaction.scanPayRefund,
      method: 'post',
      data
    })
  }
  overseaList(data) {
    return request({
      url: api.transaction.overseaList,
      method: 'post',
      data
    })
  }
  overseaExport(data) {
    return request({
      url: api.transaction.overseaExport,
      method: 'post',
      data
    })
  }
  getAccountValue(params) {
    return request({
      url: api.transaction.getAccountValue,
      method: 'get',
      params
    })
  }
}